// extracted by mini-css-extract-plugin
module.exports = {"card":"RecipeCard_card__3mwx_","imageContainer":"RecipeCard_imageContainer__23VnZ","infoContainer":"RecipeCard_infoContainer__2NKP7","diets":"RecipeCard_diets__ATQoh"};